import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IGroup, IPractitioner } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Router } from '@angular/router';

@Component({
  selector: 'inc-practitioner-list',
  templateUrl: './practitioner-list.component.html',
  styleUrls: ['./practitioner-list.component.scss'],
})
export class PractitionerListComponent {
  @Input() practitionerList: IPractitioner[];
  @Input() group: IGroup;
  @Output() removePractitioner: EventEmitter<IPractitioner> = new EventEmitter();

  constructor(private router: Router) { }

  stopProp(event: Event) {
    event.stopPropagation();
  }

  navigateTo(url: string, practitioner: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    localStorage.removeItem('practitioner');
    this.router.navigateByUrl(url, { state: { parameter: practitioner } });
  }

  removeFromGroup(practitioner: IPractitioner) {
    this.removePractitioner.emit(practitioner);
  }
}
